export default "__VITE_ASSET__B$yZgU6b__"